export const ConvertToPersianNumbers = (num) => {
  const persianNumbers = '۰۱۲۳۴۵۶۷۸۹';
  return new String(num).replace(/[0123456789]/g, (d) => {
    return persianNumbers[d];
  });
};
